export default "__VITE_ASSET__LvBx0vCw__"